import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  blockListQueryOptions,
  sharedBlockListParams,
  SharedBlocksPage,
  sharedBlockListSearchSchema,
} from '@/features/content';

export const Route = createFileRoute('/_authed/_active/org/shared-blocks/')({
  staticData: { tours: ['shared-blocks.list'] },
  // Typed as the raw input so links into the list (`<Link to="/org/shared-blocks">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    sharedBlockListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  loader: async ({ context, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...blockListQueryOptions(null, sharedBlockListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: SharedBlocksPage,
});
